// Material
import { styled } from '@mui/material/styles'
import { Box, InputBase } from '@mui/material'
// Component
import { Alert } from './alert'
import { toEnglishNumber } from '$func/text'

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  backgroundColor: theme.palette.veryVeryLightGray,
  padding: '4px 14px 3px',
  borderRadius: '8px',
  fontSize: '14px',
  fontWeight: 500,
  width: '100%',

  border: `2px solid transparent`,
  boxSizing: 'border-box',
  '&.Mui-focused': {
    backgroundColor: theme.palette.white,
    borderColor: theme.palette.secondary.main,
    padding: '4px 14px 3px',
  },
  '&.Mui-error': {
    borderColor: theme.palette.error.main,
  },
}))

interface Props {
  placeholder?: string
  disabled?: boolean
  onChange: (number: number) => void
  value: string
  successMessage?: string
  errorMessage?: string
  direction?: 'ltr' | 'rtl' | 'inherit'
  hasError?: boolean
  autoComplete?: string
  onBlur?: () => unknown
}

export function NumberInput({
  placeholder,
  disabled,
  value,
  onChange,
  successMessage = '',
  errorMessage = '',
  direction = 'inherit',
  hasError = false,
  autoComplete = '',
  onBlur,
}: Props) {
  const handleChange = (text: string) => {
    const englishValue = toEnglishNumber(text)
    /* Check for NaN value */
    if (!englishValue && text) return
    onChange(+englishValue)
  }

  return (
    <Box sx={{ marginTop: '6px', marginBottom: '15px', width: '100%' }}>
      <StyledInputBase
        placeholder={placeholder}
        disabled={disabled}
        onChange={({ target: { value: textValue } }) => handleChange(textValue)}
        value={value}
        dir={direction}
        autoComplete={autoComplete}
        onBlur={onBlur}
        inputMode="numeric"
      />

      {hasError && (
        <Alert
          variant={hasError ? 'error' : 'success'}
          text={hasError ? errorMessage : successMessage}
        />
      )}
    </Box>
  )
}
